import type { SetupTourDefinition } from '../core/types';

export const SEASONS_SETUP_TOUR_TARGETS = {
  sidebarSeasonsLink: 'seasons-sidebar-link',
  calendar: 'seasons-calendar',
  selectedSeasonPanel: 'seasons-selected-panel',
  selectedSeasonForm: 'seasons-selected-form',
  submitButton: 'seasons-submit-button',
  // Legacy targets kept for the still-reachable /seasons/create page (see SeasonCreate.tsx).
  // The tour itself no longer navigates there, so reusing `submitButton`'s value across both
  // pages is safe - only one of them is ever mounted at a time.
  calendarPreview: 'seasons-calendar-preview',
  seasonForm: 'seasons-create-form',
} as const;

export const seasonsSetupTour: SetupTourDefinition = {
  id: 'seasons_setup',
  label: 'Seasons Setup',
  onboardingKey: 'seasons_setup',
  sidebarTargetsByRoute: {
    '/seasons': SEASONS_SETUP_TOUR_TARGETS.sidebarSeasonsLink,
  },
  steps: [
    {
      id: 'sidebar-seasons',
      route: '/seasons',
      target: SEASONS_SETUP_TOUR_TARGETS.sidebarSeasonsLink,
      content: 'Click Seasons in the sidebar to set up pricing periods.',
      advanceOnTargetClick: true,
      expandSidebarKeys: ['/pricing'],
    },
    {
      id: 'calendar',
      route: '/seasons',
      target: SEASONS_SETUP_TOUR_TARGETS.calendar,
      content:
        'Select a start date and an end date to define the season range. Dates already assigned to another season are not available.',
      next: {
        guardTarget: SEASONS_SETUP_TOUR_TARGETS.calendar,
      },
    },
    {
      id: 'selected-season-form',
      route: '/seasons',
      target: SEASONS_SETUP_TOUR_TARGETS.selectedSeasonForm,
      highlightTarget: SEASONS_SETUP_TOUR_TARGETS.selectedSeasonPanel,
      position: 'left',
      content:
        'An existing season or a name for a new season is required before the tour can continue.',
      showRequiredFieldsOnEnter: true,
      next: {
        guardTarget: SEASONS_SETUP_TOUR_TARGETS.selectedSeasonForm,
      },
    },
    {
      id: 'submit-season',
      route: '/seasons',
      target: SEASONS_SETUP_TOUR_TARGETS.submitButton,
      content: 'Click Save to create the season and complete the setup',
      directNextTargets: [SEASONS_SETUP_TOUR_TARGETS.submitButton],
      next: {
        label: 'Save',
        action: { type: 'click' },
        waitForTargetRemoval: SEASONS_SETUP_TOUR_TARGETS.submitButton,
        completesTour: true,
      },
    },
  ],
};
